import React from 'react';
import map from 'mn-utils/map';
import isEqual from 'mn-utils/isEqual';
import {
  PERMISSIONS_DEFAULT,
  PERMISSIONS_SALES,
  PERMISSIONS_FINANCE,

  PERMISSION_DASHBOARD,
  PERMISSION_CURRENCY_TREND_CHART,
  PERMISSION_SALES_OVERVIEW,
  PERMISSION_PAYOUT_HISTORY,
  PERMISSION_WITHDRAW,
  PERMISSION_NOTIFICATION_SETTINGS,
  PERMISSION_ACCESS_PERMISSIONS,
  PERMISSION_EDIT_BANK_DETAILS,
  PERMISSION_SETTLEMENT_AND_REFUND_PREFERENCE,
  PERMISSION_ORDER_TERMINAL_AND_TERMINAL_DETAILS,
  PERMISSION_CHANGE_AML_PREFERENCE,
  PERMISSION_SETUP_PROMOTIONS_AND_DISCOUNTS,
  PERMISSIONS_MERCHANTS_ADMIN,
} from '../../../../../../constants/permissions';
import {
  openPopupWindow,
} from '../../../../../../emitters/popup';
import WrapperWithLoading from '../../../../../dumb/WrapperWithLoading/B';
import Popup from '../../../../../dumb/Popup/B';
import Field from '../../../../../dumb/Field/E';
import Switch from '../../../../../dumb/Switch/D';
import ButtonE from '../../../../../dumb/Button/E';
import ButtonN from '../../../../../dumb/Button/Accept';
import ButtonM from '../../../../../dumb/Button/Decline';


const ACCESS_PRESETS = [
  {
    id: 'L1',
    permissions: PERMISSIONS_DEFAULT,
  },
  {
    id: 'Admin',
    permissions: PERMISSIONS_MERCHANTS_ADMIN,
  },
  {
    id: 'Sales',
    permissions: PERMISSIONS_SALES,
  },
  {
    id: 'Finance',
    permissions: PERMISSIONS_FINANCE,
  },
];
ACCESS_PRESETS.reverse();


module.exports = (data, setPermissions) => {
  data = data || {};

  openPopupWindow((setState, self) => {
    const {
      close,
    } = self;

    const stateOfLast = {
      ...PERMISSIONS_DEFAULT,
      ...data,
    };

    const handles = map(PERMISSIONS_DEFAULT, (v, name) => {
      return (value) => {
        setStateOfCurrent({
          [name]: value,
        });
      };
    });

    self.state = {
      stateOfCurrent: stateOfLast,
    };

    function setStateOfCurrent(stateOfCurrent) {
      setState({
        stateOfCurrent: {
          ...self.state.stateOfCurrent,
          ...stateOfCurrent,
        },
      });
    }
    function handleSave() {
      setPermissions(self.state.stateOfCurrent);
      close();
    }


    return (state) => {
      const {
        stateOfCurrent,
      } = state;

      return (
        <Popup
          caption={(
            <div className="layoutRow fhaB jcSB dB@m">
              <div className="wsNW layoutRow fhaS fvaC h55 mr20">Access Settings</div>
              <div className="wmin0 cfx mh-5 (rt|lt@m|p5)>1">
                {map(ACCESS_PRESETS, (item) => {
                  const {
                    id,
                    permissions,
                  } = item;
                  return (
                    <div key={id}>
                      <ButtonE
                        className="w164"
                        checked={isEqual(permissions, stateOfCurrent)}
                        onClick={() => {
                          setStateOfCurrent(permissions);
                        }}
                      >{id}</ButtonE>
                    </div>
                  );
                })}
              </div>
            </div>
          )}
        >
          <WrapperWithLoading
            loading={state.loading}
          >
            <div className="c5B47FF>.FieldE_Label mt25 cfx mh-10 (w1/3|w1/2@m2|w@m3|ph10|lt)>1">
              <div>
                <Field
                  label="Dashboard"
                  className="mb10>1"
                >
                  <Switch
                    label="Dashboard"
                    checked={stateOfCurrent[PERMISSION_DASHBOARD]}
                    onChange={handles[PERMISSION_DASHBOARD]}
                  />
                  <Switch
                    label="Currency trend chart"
                    checked={stateOfCurrent[PERMISSION_CURRENCY_TREND_CHART]}
                    onChange={handles[PERMISSION_CURRENCY_TREND_CHART]}
                  />
                  <Switch
                    label="Sales overview"
                    checked={stateOfCurrent[PERMISSION_SALES_OVERVIEW]}
                    onChange={handles[PERMISSION_SALES_OVERVIEW]}
                  />
                  <Switch
                    label="Payout history"
                    checked={stateOfCurrent[PERMISSION_PAYOUT_HISTORY]}
                    onChange={handles[PERMISSION_PAYOUT_HISTORY]}
                  />
                  <Switch
                    label="Withdraw"
                    checked={stateOfCurrent[PERMISSION_WITHDRAW]}
                    onChange={handles[PERMISSION_WITHDRAW]}
                  />
                </Field>
              </div>
              <div className="mt25@m1">
                <Field
                  label="Settings"
                  className="mb10>1"
                >
                  <Switch
                    label="Notification settings"
                    checked={stateOfCurrent[PERMISSION_NOTIFICATION_SETTINGS]}
                    onChange={handles[PERMISSION_NOTIFICATION_SETTINGS]}
                  />
                  <Switch
                    label="Access permissions"
                    checked={stateOfCurrent[PERMISSION_ACCESS_PERMISSIONS]}
                    onChange={handles[PERMISSION_ACCESS_PERMISSIONS]}
                  />
                </Field>
              </div>
              <div className="mt25@m2">
                <Field
                  label="Management"
                  className="mb10>1"
                >
                  <Switch
                    label="Edit bank details"
                    checked={stateOfCurrent[PERMISSION_EDIT_BANK_DETAILS]}
                    onChange={handles[PERMISSION_EDIT_BANK_DETAILS]}
                  />
                  <Switch
                    label="Settlement and refund preference"
                    checked={stateOfCurrent[PERMISSION_SETTLEMENT_AND_REFUND_PREFERENCE]}
                    onChange={handles[PERMISSION_SETTLEMENT_AND_REFUND_PREFERENCE]}
                  />
                  <Switch
                    label="Order terminal and terminal details"
                    checked={stateOfCurrent[PERMISSION_ORDER_TERMINAL_AND_TERMINAL_DETAILS]}
                    onChange={handles[PERMISSION_ORDER_TERMINAL_AND_TERMINAL_DETAILS]}
                  />
                  <Switch
                    label="Change AML preference"
                    checked={stateOfCurrent[PERMISSION_CHANGE_AML_PREFERENCE]}
                    onChange={handles[PERMISSION_CHANGE_AML_PREFERENCE]}
                  />
                  <Switch
                    label="Setup Promotions and discounts"
                    checked={stateOfCurrent[PERMISSION_SETUP_PROMOTIONS_AND_DISCOUNTS]}
                    onChange={handles[PERMISSION_SETUP_PROMOTIONS_AND_DISCOUNTS]}
                  />
                </Field>
              </div>
            </div>
            <div className="cfx mt10 mh-28 (lt|ph28|pb20)>1">
              <div>
                <ButtonN
                  disabled={isEqual(stateOfLast, stateOfCurrent)}
                  onClick={handleSave}
                >Save</ButtonN>
              </div>
              <div>
                <ButtonM
                  onClick={close}
                >Cancel</ButtonM>
              </div>
            </div>
          </WrapperWithLoading>
        </Popup>
      );
    };
  });
};
